import translation from 'locales/translation';

export enum AssemblyType {
  AGN = 'AGN',
  AGO = 'AGO',
  AGE = 'AGE',
  AOE = 'AOE',
  REU = 'REU',
}

export enum AssemblyTypeText {
  AGN = 'AGN - Assembleia de Núcleo',
  AGE = 'AGE - Assembleia Geral Extraordinária ',
  AGO = 'AGO - Assembleia Geral Ordinária',
  AOE = 'AOE - Assembleia Ordinária Extraordinária  ',
  REU = 'REU - Reunião de Núcleo',
}

export enum AssemblyModalitiesNumber {
  OFFLINE = 1,
  HIBRIDO_PRESENCIAL_DIGITAL = 2, // Assíncrono - Presencial e digital
  HIBRIDO_DIGITAL_AGENCIA = 3,
  ONLINE = 4,
  HIBRIDO_SIMULTANEO = 5, // Simultâneo - Digital e presencial
}

export enum ModalityType {
  OFFLINE = 0,
  ONLINE = 1,
  AGENCIA = 2,
  PRESENCIAL = 3,
}

export enum AssemblyModalities {
  OFFLINE = 'OFFLINE',
  ONLINE = 'ONLINE',
  HIBRIDO_PRESENCIAL_DIGITAL = 'HIBRIDO_PRESENCIAL_DIGITAL',
  HIBRIDO_DIGITAL_AGENCIA = 'HIBRIDO_DIGITAL_AGENCIA',
  HIBRIDO_SIMULTANEO = 'HIBRIDO_SIMULTANEO',
}

export enum AssemblyModalitiesTemplate {
  OFFLINE = 'ASSEMBLEIAS_PRESENCIAL',
  ONLINE = 'ASSEMBLEIAS_DIGITAL',
  HIBRIDO_PRESENCIAL_DIGITAL = 'ASSEMBLEIAS_SEMIPRESENCIAL',
  HIBRIDO_DIGITAL_AGENCIA = 'ASSEMBLEIAS_SEMIPRESENCIAL',
  HIBRIDO_SIMULTANEO = 'ASSEMBLEIAS_SEMIPRESENCIAL',
}

// export enum ModeloPesquisa {
//   COOP_PONTA_LAPIS = 'COOP_PONTA_LAPIS',
//   ASSEMBLEIAS_DIGITAL = 'ASSEMBLEIAS_DIGITAL',
//   ASSEMBLEIAS_PRESENCIAL = 'ASSEMBLEIAS_PRESENCIAL',
//   ASSEMBLEIAS_SEMIPRESENCIAL = 'ASSEMBLEIAS_SEMIPRESENCIAL',
//   AGENDAMENTO_ESP_EXTERNO = 'AGENDAMENTO_ESP_EXTERNO',
//   AGENDAMENTO_VIS_INSTITUCIONAL = 'AGENDAMENTO_VIS_INSTITUCIONAL'
// }

export enum AssemblyModalityText {
  OFFLINE = 'Presencial',
  ONLINE = 'Digital',
  HIBRIDO_PRESENCIAL_DIGITAL = 'Assíncrono - Presencial e digital',
  HIBRIDO_DIGITAL_AGENCIA = 'Simultâneo - Digital e agência',
  HIBRIDO_SIMULTANEO = 'Simultâneo - Digital e presencial',
}

export enum AssemblyStatus {
  NAO_DISPONIVEL = 0,
  PRE = 1,
  LIVE = 2,
  POS = 3,
  ENCERRADO = 4,
  ENCERRADO_SEM_QUORUM = 5,
}

export enum LegacyStatus {
  EDITABLE = 0,
  AVAILABLE_OR_BLOCKED = 1,
  FINISHED = 2,
  RESERVABLE = 3,
  EXPIRED = 4,
}

export enum AssemblyStatusMensagens {
  BLOQUEADO = 0,
  LIBERADO_CONVOCADOS = 1,
  LIBERADO_TODOS = 2,
}

export enum AssemblyTipoDocumentoPertencer {
  DESCONHECIDO = 'DESCONHECIDO',
  EDITAL = 'EDITAL',
  ATAS = 'ATAS',
  FOTOS = 'FOTOS',
}

export enum Toggle {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export enum StepStatus {
  CRIACAO = 'CRIACAO',
  EM_EDICAO = 'EM_EDICAO',
  VISUALIZACAO = 'VISUALIZACAO',
}

export enum StaveTypeNumber {
  PADRAO = 0,
  CONSELHO = 1,
  COORDENADOR = 2,
}

export enum StaveTypeString {
  PADRAO = 'Padrão',
  CONSELHO = 'Conselho',
  COORDENADOR = 'Coordenador',
}

export enum StepIds {
  data = 'dados',
  entity = 'entidade',
  local = 'local',
  staves = 'pauta',
  survey = 'pesquisa',
  attachment = 'anexo',
}

export enum SituationValues {
  EDITABLE = 'EDITABLE',
  AVAILABLE = 'AVAILABLE',
  BLOCKED = 'BLOCKED',
  RESERVABLE = 'RESERVABLE',
  IN_PREPARATION = 'IN_PREPARATION',
  IN_ASSEMBLY = 'IN_ASSEMBLY',
  FINISHED = 'FINISHED',
  EXPIRED = 'EXPIRED',
}

export enum SituationText {
  EDITABLE = 'Em edição',
  AVAILABLE = 'Disponível',
  BLOCKED = 'Bloqueado',
  RESERVABLE = 'Reservado',
  IN_PREPARATION = 'Em preparação',
  IN_ASSEMBLY = 'Em assembleia',
  FINISHED = 'Finalizada',
  EXPIRED = 'Expirado',
}

export enum ConvocationStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  RUNNING = 'RUNNING',
}

export enum SurveyEventType {
  COOP_PONTA_LAPIS = 1,
  ASSEMBLEIAS_DIGITAL = 2,
  ASSEMBLEIAS_PRESENCIAL = 3,
  ASSEMBLEIAS_SEMIPRESENCIAL = 4,
}

export enum EditVoteCardKeys {
  ASSOCIADOS_CONVOCADOS = translation.Assessor.Evento.Vote.cards
    .associadosConvocados as any,
  ASSOCIADOS_PRESENTES = translation.Assessor.Evento.Vote.cards
    .associadosPresentes as any,
  ASSOCIADOS_APTOS = translation.Assessor.Evento.Vote.cards
    .associadosAptos as any,
  CONVIDADOS_PRESENTES = translation.Assessor.Evento.Vote.cards
    .convidadosPresentes as any,
  TOTAL_DE_PARTICIPANTES = translation.Assessor.Evento.Vote.cards
    .totalDeParticipantes as any,
}

export enum AssemblyEventText {
  ALL = 'Todos os eventos',
  ONLY_TEST = 'Eventos de teste',
  ONLY_OFFICIALS = 'Eventos oficiais',
}

export enum AssemblyEventValue {
  ALL = 'ALL',
  ONLY_TEST = 'ONLY_TEST',
  ONLY_OFFICIALS = 'ONLY_OFFICIALS',
}
